import type { FaireProductEntity } from "../../entity_types/product";

export const p_9q595cvfmj: FaireProductEntity = {
  token: "p_9q595cvfmj",
  type: "product",
  name: "Kid Book My LullaBible for Boys Padded Hardcover Board Book",
  brandToken: "b_3811aa80",
  brandName: "Christian Art Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/bb5ce1ed2e151e5bf5fc2c9b0c8e62f5a1b4bcb9cfdc4945c9ebe53c3a879b89.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed3a8d68f33e91128023a82ba5aa41b884c20dfcf545f10f86f9b4d491921d36.jpeg",
    "https://cdn.faire.com/fastly/e86e9f2eb43f92f2f58251413e19f19b3b49aec099d2a927ad4d44914eb2aff9.jpeg",
    "https://cdn.faire.com/fastly/59189c20e740ab448c13f3ec02c6327b50028d1d45eb32ef73781a1857d249d6.jpeg",
  ],
  priceDollars: 10.39,
  description:
    'The  My LullaBible for Boys is an enchanting collection of 24 soothing lullabies for baby boys, instilling a love of God in their hearts. With its beautiful design and meaningful poetry, this is a must-have for any family with small children.\n52 Full-Color Pages, Padded Hardcover Bound Board Book, Brilliant Full-Color Illustrations, Silver Foil Cover Accents, Personalization Page for Gift-Giving, Size: 8.5" x 7.7" x 1.6" (216 x 196 x 41mm)',
  tags: [],
  msrpDollars: 20.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:03.160Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
